import { render } from "./SelectPostDialog.vue?vue&type=template&id=1b57dab6"
import script from "./SelectPostDialog.vue?vue&type=script&lang=js"
export * from "./SelectPostDialog.vue?vue&type=script&lang=js"

import "./SelectPostDialog.vue?vue&type=style&index=0&id=1b57dab6&lang=scss&scope=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__